<template>
  <v-row density="compact">
    <div v-if="rule.config && rule.config.type">
      <v-btn size="small" @click="updateConfig('type', null)"> Use Old Rules Instead </v-btn>

      <v-radio-group
        :model-value="rule.config.type"
        class="mt-0"
        @update:model-value="updateConfig('type', $event)"
      >
        <v-row density="compact">
          <v-col cols="12">
            <v-row density="compact">
              <v-col cols="12">
                <v-radio style="white-space:normal"
                  :value="1"
                >
              <template #label>
                Match stocks that have&#160;<strong class="red-text">under</strong>performed the S&amp;P
  </template>
              </v-radio>
              </v-col>
              <v-col cols="12" sm="12" md="7">
                <v-select
                  :model-value="rule.config.months"
                  density="compact"
                  hide-details
                  variant="outlined"
                  :items="stocks_vs_sp_months"
                  :disabled="parseInt(rule.config.type) != 1"
                  item-title="text"
                  item-value="value"
                  prefix="over the past"
                  label="Trading days"
                  @update:model-value="updateConfig('months', $event)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  :model-value="rule.config.percentage_points"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix="by at least"
                  :disabled="parseInt(rule.config.type) != 1"
                  label=""
                  suffix="percentage points"
                  placeholder=""
                  @update:model-value="updateConfig('percentage_points', $event)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  :model-value="rule.config.percentage_points_max"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix=""
                  :disabled="parseInt(rule.config.type) != 1"
                  label="optional max"
                  placeholder="optional max"
                  @update:model-value="updateConfig('percentage_points_max', $event)"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row density="compact">
              <v-col cols="12">
                <v-radio
                  :value="2"
                >
              <template #label>
                Match stocks that have&#160;<strong>out</strong>performed the S&amp;P
  </template>
              </v-radio>
              </v-col>
              <v-col cols="12" sm="12" md="7">
                <v-select
                  :model-value="rule.config.months"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix="over the past"
                  :items="stocks_vs_sp_months"
                  item-title="text"
                  :disabled="parseInt(rule.config.type) != 2"
                  item-value="value"
                  label="Trading days"
                  @update:model-value="updateConfig('months', $event)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  :model-value="rule.config.percentage_points"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix="by at least"
                  :disabled="parseInt(rule.config.type) != 2"
                  label=""
                  suffix="percentage points"
                  placeholder=""
                  @update:model-value="updateConfig('percentage_points', $event)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  :model-value="rule.config.percentage_points_max"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix=""
                  :disabled="parseInt(rule.config.type) != 2"
                  label="optional max"
                  placeholder="optional max"
                  @update:model-value="updateConfig('percentage_points_max', $event)"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row density="compact">
              <v-col cols="12">
                <v-radio
                  :value="3"
                >
               <template #label>
                Match stocks that have&#160;<strong>under</strong>performed the S&amp;P
  </template>
              </v-radio>
              </v-col>
              <v-col cols="12" sm="12" md="7">
                <v-select
                  :model-value="rule.config.months"
                  density="compact"
                  hide-details
                  variant="outlined"
                  :items="stocks_vs_sp_months"
                  item-title="text"
                  :disabled="parseInt(rule.config.type) != 3"
                  item-value="value"
                  prefix="over the past"
                  label="Trading days"
                  @update:model-value="updateConfig('months', $event)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  :model-value="rule.config.percent_threshold"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix="by at least"
                  label=""
                  :disabled="parseInt(rule.config.type) != 3"
                  suffix="percent"
                  placeholder=""
                  @update:model-value="updateConfig('percent_threshold', $event)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  :model-value="rule.config.percent_threshold_max"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix=""
                  :disabled="parseInt(rule.config.type) != 3"
                  label="optional max"
                  placeholder="optional max"
                  @update:model-value="updateConfig('percent_threshold_max', $event)"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row density="compact">
              <v-col cols="12">
                <v-radio
                  :value="4"
                >
               <template #label>
                Match stocks that have&#160;<strong>out</strong>performed the S&amp;P
  </template>  
              </v-radio>

              </v-col>
              <v-col cols="12" sm="12" md="7">
                <v-select
                  :model-value="rule.config.months"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix="over the past"
                  :items="stocks_vs_sp_months"
                  item-title="text"
                  item-value="value"
                  :disabled="parseInt(rule.config.type) != 4"
                  label="Trading days"
                  @update:model-value="updateConfig('months', $event)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  :model-value="rule.config.percent_threshold"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix="by at least"
                  label=""
                  suffix="percent"
                  placeholder=""
                  :disabled="parseInt(rule.config.type) != 4"
                  @update:model-value="updateConfig('percent_threshold', $event)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  :model-value="rule.config.percent_threshold_max"
                  density="compact"
                  hide-details
                  variant="outlined"
                  prefix=""
                  :disabled="parseInt(rule.config.type) != 4"
                  label="optional max"
                  placeholder="optional max"
                  @update:model-value="updateConfig('percent_threshold_max', $event)"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-radio-group>
    </div>
    <v-card-text v-show="!rule.config.type" style="height: 380px">
      <v-container>
        <v-row density="compact">
          <v-col cols="12" sm="6">
            <v-select
              :model-value="rule.config.months"
              density="compact"
              hide-details
              variant="outlined"
              :items="stocks_vs_sp_months"
              item-title="text"
              item-value="value"
              label="Trading days"
              @update:model-value="updateConfig('months', $event)"
            />
          </v-col>
          <v-col v-if="1 == 2" cols="12" sm="6">
            <v-select
              :model-value="rule.config.up_or_down"
              density="compact"
              hide-details
              variant="outlined"
              :items="stocks_vs_sp_up_down"
              label="Up or Down"
              single-line
              @update:model-value="updateConfig('up_or_down', $event)"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              :model-value="rule.config.percent_threshold"
              density="compact"
              hide-details
              variant="outlined"
              label="Performance vs S&amp;P % Min."
              placeholder="Min. Performance %"
              @update:model-value="updateConfig('percent_threshold', $event)"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              :model-value="rule.config.percent_threshold_max"
              density="compact"
              hide-details
              variant="outlined"
              label="Performance vs S&amp;P % Max"
              placeholder="Max. Performance %"
              @update:model-value="updateConfig('percent_threshold_max', $event)"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              :model-value="rule.config.consecutive_days"
              density="compact"
              hide-details
              variant="outlined"
              label="Consecutive days of outperformance"
              @update:model-value="updateConfig('consecutive_days', $event)"
            />
          </v-col>
        </v-row>
        <v-row density="compact">
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              :model-value="rule.config.plus_minus"
              density="compact"
              hide-details
              variant="outlined"
              label="Statistically Significant: Min."
              @update:model-value="updateConfig('plus_minus', $event)"
            />
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-text-field
              :model-value="rule.config.plus_minus_max"
              density="compact"
              hide-details
              variant="outlined"
              label="Statistically Significant: Max."
              @update:model-value="updateConfig('plus_minus_max', $event)"
            />
          </v-col>

          <v-col v-if="1 == 2" cols="12" sm="6">
            <v-text-field
              :model-value="rule.config.allocation"
              density="compact"
              hide-details
              label="% Allocated to Signal"
              hint="% of total trend signal resources devoted to this breakout model"
              persistent-hint
              @update:model-value="updateConfig('allocation', $event)"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      high_low: ['new high', 'new low'],
      stocks_vs_sp_months: [
        { text: '20 trading days', value: 1 },
        { text: '60 trading days', value: 3 },
        { text: '120 trading days', value: 6 },
        { text: '180 trading days', value: 9 },
        { text: '240 trading days', value: 12 },
        { text: '480 trading days', value: 24 }
      ],
      volume_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '90 Days', value: 90 }
      ],
      days_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '50 days', value: 50 },
        { text: '90 days', value: 90 },
        { text: '6-months', value: 180 },
        { text: '1 Year', value: 365 }
      ],
      editedIndex: -1,
      editedSp: {
        rule_type: 'perf_vs_sp',
        type: 1,
        percentage_points: 3,
        percentage_points_max: null,
        long_short: 'long',
        percent_threshold: 10.0,
        percent_threshold_max: null,
        months: 3,
        up_or_down: 'down',
        plus_minus: null,
        plus_minus_max: null,
        allocation: 100,
        consecutive_days: null,
        enabled: true
      },
      defaultSp: {
        rule_type: 'perf_vs_sp',
        type: 1,
        percentage_points: 3,
        percentage_points_max: null,
        long_short: 'long',
        percent_threshold: 10.0,
        percent_threshold_max: null,
        months: 3,
        up_or_down: 'down',
        plus_minus: null,
        plus_minus_max: null,
        allocation: 100,
        consecutive_days: null,
        enabled: true
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  beforeMount() {
    if (
      !this.rule.config ||
      !this.rule.config.rule_type ||
      this.rule.trend != 'perf_vs_sp' ||
      (!this.rule.config.type && !this.rule.config.months)
    ) {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultSp) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
